export const SwitchArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="w-16-md"
    >
      <path
        d="M18 8L6 8M6 8L10.125 4M6 8L10.125 12"
        stroke="#C81832"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 16L18 16M18 16L13.875 12M18 16L13.875 20"
        stroke="#C81832"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
